import { api as commonApi } from '..';
import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { CommonEpic } from 'common/types';

import resourcesActionTypes from './actionTypes';
import {
  actionSuccessGetLanguages,
  actionSuccessGetResources,
  actionErrorGetResources,
  actionErrorGetLanguages,
} from './actions';

export const epicGetResources: CommonEpic<typeof commonApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(resourcesActionTypes.LOADING_GET_RESOURCES),
    mergeMap((action) =>
      from(api.getResources(action.payload)).pipe(
        mergeMap((response) => of(actionSuccessGetResources({ ...response, culture: action.payload }))),
        catchError((error) => of(actionErrorGetResources(error))),
      ),
    ),
  );

export const epicGetLanguages: CommonEpic<typeof commonApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(resourcesActionTypes.LOADING_GET_LANGUAGES),
    mergeMap(() =>
      from(api.getLanguages()).pipe(
        mergeMap((response) => of(actionSuccessGetLanguages(response))),
        catchError((error) => of(actionErrorGetLanguages(error))),
      ),
    ),
  );
